import React from "react";

const OrganizationContext = React.createContext(null);

export default OrganizationContext;
